<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Edit Terms Date">
      <v-card flat class="px-2">
        <form @submit.prevent="Save">
          <v-row>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">Select Academic Term</label>
              <v-text-field class="my-0 py-1" required disabled v-model="TermObject.term" maxlength="50" counter="50" />
            </v-col>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">From Date <span class="error--text">*</span></label>
              <custom-date-picker v-model="TermObject.fromDate" required />
            </v-col>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">To Date<span class="error--text">*</span></label>
              <custom-date-picker v-model="TermObject.toDate" :min="TermObject.fromDate" required />
            </v-col>
            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" :disabled="hasClicked" color="primary" type="submit">
                  <v-icon left> mdi-content-save </v-icon>
                  Save
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card>
    </material-card>
    <!-- <loading-icon :value="isLoading" /> -->
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'
export default {
  name: 'editTerm',
  components: { MaterialCard, CustomDatePicker },
  props: ['termMapID'],
  data () {
    return {
      hasClicked: false,
      loader: true,
      TermObject: {
        id: '',
        term: '',
        fromDate: '',
        toDate: ''
      },
      maxToDate: moment().format('YYYY-MM-DD')
    }
  },
  async created () {
    await this.termList(this.termMapID)
  },
  methods: {
    termList: async function () {
      try {
        let { data } = await http.get(`${constants.API_URL}/api/grade-module/academic-terms/date/map/${this.termMapID}`)

        if (data) {
          this.TermObject = {
            id: data[0].id,
            term: data[0].academicTerm.name,
            fromDate: moment(data[0].fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
            toDate: moment(data[0].toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    Save: async function () {
      this.hasClicked = true
      let formData = {
        fromDate: this.TermObject.fromDate,
        toDate: this.TermObject.toDate
      }
      try {
        await http.put(`${constants.API_URL}/api/grade-module/update-academic-terms/date/map/${this.termMapID}`, formData)
        this.loader = false
        this.$router.push({ name: 'termDetails' })
        return this.$dialog.info({
          title: 'Success',
          text: 'Saved successfully'
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Enquiry Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    }
  }
}
</script>
